<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss"></style>
<template>
  <div style="width: 100%;">
    <div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
      <!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #303133;">
        {{ $t('ziduanpeizhi') }}
      </p>
    </div>
    <div style="display: flex;width: 100%;justify-content: center;height: 280px;margin-top: 20px;">
      <el-transfer
        target-order="push"
        style="text-align: left; display: inline-block"
        v-model="monitorSetting.PRODUCTION_COLUMNS"
        :titles="[$t('yincanglie'), $t('xianshilie')]"
        :format="{
          noChecked: '${total}',
          hasChecked: '${checked}/${total}'
        }"
        @change="showColumnsChange"
        :data="allColumns"
      >
        <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;">
          <div>{{ $t(option.label) }}</div>
          <div>
            <!-- <i @click="columnUp($event,option.label)" class="el-icon-bottom" style="font-size: 14px;"></i> -->
          </div>
        </div>
      </el-transfer>
    </div>
    <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
      <!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #303133;">
        {{ $t('shebeizhuangtai') }}
      </p>
    </div>
    <div style="display: flex;align-items: center;margin-top: 12px;">
      <div style="display: flex;flex-direction: column;">
        <el-radio v-model="monitorSetting.PRODUCTION_STATUS_SHOW_TYPE" label="moren">{{ $t('moren') }} </el-radio>
      </div>
      <div style="display: flex;flex-direction: column;margin-left: 80px;">
        <el-radio v-model="monitorSetting.PRODUCTION_STATUS_SHOW_TYPE" label="yincanglixianzhuangtai">
          {{ $t('yincanglixianzhuangtai') }}
        </el-radio>
      </div>
    </div>

    <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #303133;">
        {{ $t('kapiankuandu') }}
      </p>
    </div>
    <div style="display: flex;align-items: center;padding-top: 14px;">
      <!-- <p>{{$t('meigekapiankuandu')}}</p> -->
      <el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.PRODUCTION_CARD_WIDTH"></el-input-number>
      <p style="margin-left: 12px;">px</p>
    </div>

    <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #303133;">
        {{ $t('kapianziti') }}
      </p>
    </div>
    <div style="display: flex;align-items: center;padding-top: 14px;">
      <!-- <p>{{$t('meigekapiankuandu')}}</p> -->
      <el-input-number style="margin-left: 12px;" size="mini" v-model="monitorSetting.PRODUCTION_CARD_FONT_SIZE"></el-input-number>
      <p style="margin-left: 12px;">px</p>
    </div>
    <div style="margin-top: 40px;"></div>
    <!-- 	<div style="display: flex;align-items: center;margin-top: 12px;">
					<div style="display: flex;flex-direction: column;">
						<el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="jianyue">{{$t('jianyue')}}
						</el-radio>
						<img style="width: 161px;height: 204px;margin-top: 12px;"
							src="../../../../assets/img/web/workshop/jianyue.jpg" />
					</div>
					<div style="display: flex;flex-direction: column;margin-left: 80px;">
						<el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="tianchong">
							{{$t('tianchong')}}
						</el-radio>
						<img style="width: 161px;height: 204px;margin-top: 12px;"
							src="../../../../assets/img/web/workshop/tianchong.jpg" />
					</div>

				</div> -->
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_production_setting',
  components: {},

  data() {
    return {
      monitorSetting: {},
      allColumns: [
        {
          key: 'shebeimingcheng',
          label: this.$t('shebeimingcheng'),
          disabled: true
        },
        {
          key: 'dangqianmohao',
          label: this.$t('dangqianmohao'),
          disabled: false
        },
        {
          key: 'dangqianliaohao',
          label: this.$t('dangqianliaohao'),
          disabled: false
        },
        {
          key: 'shebeizhuangtai',
          label: this.$t('shebeizhuangtai'),
          disabled: false
        },
        {
          key: 'jihuachanliang',
          label: this.$t('jihuachanliang'),
          disabled: false
        },
        {
          key: 'jihuachanliangziding',
          label: this.$t('jihuachanliangziding'),
          disabled: false
        },
        {
          key: 'leijichanliang',
          label: this.$t('leijichanliang'),
          disabled: false
        },
        {
          key: 'banzhichanliang',
          label: this.$t('banzhichanliang'),
          disabled: false
        },
        {
          key: 'shangyimozhouqi',
          label: this.$t('shangyimozhouqi'),
          disabled: false
        },
        {
          key: 'shengchanjindu',
          label: this.$t('shengchanjindu'),
          disabled: false
        },
        {
          key: 'shengchanjinduziding',
          label: this.$t('shengchanjinduziding'),
          disabled: false
        },
        {
          key: 'wangongyuceshijian',
          label: this.$t('wangongyuceshijian'),
          disabled: false
        }
      ]
    };
  },
  created() {
    this.resetData();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  methods: {
    showColumnsChange(e) {},
    resetData() {
      //可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }

      this.monitorSetting.PRODUCTION_COLUMNS = this.monitorSetting.PRODUCTION_COLUMNS != null ? this.monitorSetting.PRODUCTION_COLUMNS : ['shebeimingcheng', 'dangqianmohao', 'dangqianliaohao', 'shebeizhuangtai', 'jihuachanliang', 'jihuachanliangziding', 'leijichanliang', 'banzhichanliang', 'shangyimozhouqi', 'shengchanjindu', 'shengchanjinduziding', 'wangongyuceshijian'];
      this.monitorSetting.PRODUCTION_STATUS_SHOW_TYPE = this.monitorSetting.PRODUCTION_STATUS_SHOW_TYPE != null ? this.monitorSetting.PRODUCTION_STATUS_SHOW_TYPE : 'moren';
      this.monitorSetting.PRODUCTION_CARD_WIDTH = this.monitorSetting.PRODUCTION_CARD_WIDTH != null ? this.monitorSetting.PRODUCTION_CARD_WIDTH : 350;
      this.monitorSetting.PRODUCTION_CARD_FONT_SIZE = this.monitorSetting.PRODUCTION_CARD_FONT_SIZE != null ? this.monitorSetting.PRODUCTION_CARD_FONT_SIZE : 14;

      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 500);
    },
    save() {
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));

      //首次进入的时候row可能还没出来，这时候emit row还没on，所以没有触发，这里加一个nextTick
      // this.$next
      this.utils.event_hub.$emit('SetProduction');
    }
  }
};
</script>
